import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState({
    statuses: translate({ id: 'global.statuses' }),
    unassigned: translate({ id: 'map.tooltip.order.status.unassigned' }),
    notDispatched: translate({ id: 'map.tooltip.order.status.notDispatched' }),
    todo: translate({ id: 'map.tooltip.order.status.todo' }),
    completed: translate({ id: 'map.tooltip.order.status.completed' }),
    notCompleted: translate({ id: 'map.tooltip.order.status.notCompleted' }),
    undeclared: translate({ id: 'map.tooltip.order.status.undeclared' }),
    routes: (count: number) => translate({ id: 'map.tooltip.order.routes', values: { count } }),
  })

  return api
}
